__turbopack_context__.v({
  "dataTableTable": "_8pYEiq_dataTableTable",
  "datatable": "_8pYEiq_datatable",
  "dragHandle": "_8pYEiq_dragHandle",
  "dragHandleIcon": "_8pYEiq_dragHandleIcon",
  "draggableColumnGrip": "_8pYEiq_draggableColumnGrip",
  "draggableColumnGripButton": "_8pYEiq_draggableColumnGripButton",
  "draggableColumnText": "_8pYEiq_draggableColumnText",
  "draggableColumnTitle": "_8pYEiq_draggableColumnTitle",
  "draggableColumnTitleOver": "_8pYEiq_draggableColumnTitleOver",
  "editRowButton": "_8pYEiq_editRowButton",
  "headerBelowToolbar": "_8pYEiq_headerBelowToolbar",
  "hoverStickyLastColumn": "_8pYEiq_hoverStickyLastColumn",
  "lockIcon": "_8pYEiq_lockIcon",
  "pagination": "_8pYEiq_pagination",
  "resetButton": "_8pYEiq_resetButton",
  "resetIcon": "_8pYEiq_resetIcon",
  "resizableColumnHandle": "_8pYEiq_resizableColumnHandle",
  "resizableColumnHeader": "_8pYEiq_resizableColumnHeader",
  "resizableColumnText": "_8pYEiq_resizableColumnText",
  "sortableColumn": "_8pYEiq_sortableColumn",
  "table": "_8pYEiq_table",
  "unselectableSelectionReason": "_8pYEiq_unselectableSelectionReason",
});
